var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('Page',{attrs:{"title":"My Orders"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('YearSelector',{on:{"select":_vm.load}})]},proxy:true}])},[_c('OrderView',{attrs:{"loading":_vm.loading}}),_c('DelivTracking'),_c('div',{staticClass:"text-center my-10"},[_c('FAQ')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }